export namespace IAlertBannerPageType {
  export enum Enum {
    ENUM_UNKNOWN = 'ENUM_UNKNOWN',
    /**
     * Default page behavior means that there is no special case logic based
     * on which page the user is on.
     */
    DEFAULT = 'DEFAULT',
    /**
     * There are certain banners that we only want to show when the user is
     * on the orders and reviews page.
     */
    RETAILER_ORDERS_AND_REVIEWS_PAGE = 'RETAILER_ORDERS_AND_REVIEWS_PAGE',
    /**
     * There are certain banners that we only want to show when the user is
     * on the homepage.
     */
    RETAILER_HOMEPAGE = 'RETAILER_HOMEPAGE',
    /**
     * There are certain banners that we only want to show when the user is
     * on the point-of-sale page.
     */
    RETAILER_POS_PAGES = 'RETAILER_POS_PAGES',
    /**
     * There are certain banners that we do NOT want to show on the post
     * post order page
     */
    RETAILER_POST_ORDER_PAGE = 'RETAILER_POST_ORDER_PAGE',
    /**
     * There are certain banners that we only want to show when the user is
     * on the my team page.
     */
    RETAILER_MY_TEAM_PAGE = 'RETAILER_MY_TEAM_PAGE',
    /**
     * There are certain banners that we only want to show when the user is
     * on the brand preview page.
     * @deprecated
     */
    BRAND_PREVIEW_PAGE = 'BRAND_PREVIEW_PAGE',
    /**
     * There are certain banners that we only want to show when the user is
     * on the brand page.
     */
    BRAND_PAGE = 'BRAND_PAGE',
    /**
     * There are certain banners that we do NOT want to show on the Promoted Listings section of brand portal
     * because duplicative banners already show up in the page content
     */
    BRAND_PORTAL_PROMOTED_LISTINGS_PAGE = 'BRAND_PORTAL_PROMOTED_LISTINGS_PAGE',
  }

  /**
   * Return an instance of IAlertBannerPageType with the provided fields. Any field not
   * listed will be populated with an empty value (an empty array,
   * or undefined, whichever is valid for the type of the value.)
   */
  export const build = (
    partial?: Partial<IAlertBannerPageType>
  ): IAlertBannerPageType =>
    ({
      ...(partial ?? {}),
    }) as IAlertBannerPageType;
}

/**
 * Some banners have different behavior based on page type, so clients
 * will tell the backend which page type the user is on when it asks
 * for alert banners.
 */
export interface IAlertBannerPageType {}
